import React from 'react';
import { createTableElementClassName } from './tableStyles';

type CellSize = 'auto' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

type Props = {
  text: React.ReactNode;
  size: CellSize;
  sorted?: boolean;
  ascending?: boolean;
  onClick?(): void;
};

export const TableTh = (props: Props) => {
  const { text, sorted, ascending, size, onClick } = props;

  const className = createTableElementClassName('cell', {
    th: true,
    sorted,
    asc: ascending,
    desc: !ascending,
    size,
  });

  return (
    <th className={className} onClick={onClick}>
      {text}
    </th>
  );
};
